require('/ui/components/pagination/paginationcontrols.module.scss.module.css');

export const infoLoading = "_info-loading_qpnzu_1";
export const paginationButton = "_pagination-button_qpnzu_1";
